<template>
	<Modal v-model="modalShow"
           @on-ok="handleSubmit"
           title="选择主店">
      <el-select
style="width: 100%;"
:value="selectShop"
filterable
remote
placeholder="输入搜索店铺"
:remote-method="remoteMethod"
@change="onChange"
          >
          <el-option
            v-for="i in otherShops"
            :value="i.id"
            :key="i.id"
            :label="i.name"
          >
          </el-option>
        </el-select>
    </Modal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'BindingMainShop',
  components: {},
  data () {
    return {
      selectShop: '',
      searchValue: '',
	    modalShow: false
    }
  },
  computed: {
    ...mapGetters('shop', ['shops', 'otherShops',  'meta', 'loading']),
  },
  created () {
    this.index()
  },
  methods: {
    ...mapActions('shop', [
      'index',
      'changeQuery'
    ]),
    ...mapMutations('shop', ['changeQuery']),

    remoteMethod (query) {
      if (query !== '') {
        this.searchValue = query
        this.changeQuery({ 'q[name_eq]': this.searchValue })
        this.index()
      }
    },
    onChange (value) {
	    this.selectShop = value;
    },
	handleSubmit () {
	  console.log('this.selectShop', this.selectShop);
      this.$emit('bind', this.selectShop)
    },
	show() {
	  this.modalShow = !this.modalShow
	}
  }
}
</script>

<style lang='scss' scoped>
</style>
